import React, { Component } from 'react';
import { CircularProgress, Button, Grid, Cell } from 'react-md';
import RoomsItem from './RoomsItem';
import CreateRoomDialog from './CreateRoomDialog'

const pubSub = require('./util/pubsub');

class Rooms extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showRoomNameDialog: false,
            createRoomName: ''
        };
        this.loadRooms();
        this.loadRooms = this.loadRooms.bind(this);
    }

    loadRooms() {

        const dis = this;

        pubSub.pub(pubSub.EVENT_REQUEST_START);

        this.props.service.fs.collection('rooms').get()
            .then(snap => {

                pubSub.pub(pubSub.EVENT_REQUEST_END);

                var newRooms = [];

                snap.forEach(doc => {

                    let { seat0, seat1, seat2, seat3, name } = doc.data();

                    let newRoom = {
                        id: doc.id,
                        name: name
                    };

                    var count = 0;
                    let seats = [seat0, seat1, seat2, seat3];
                    seats.forEach((e, i) => {

                        let seat = seats[i];
                        var label = undefined;

                        if (seat !== undefined && seat.uid !== undefined) {
                            count++;
                            label = seat.displayName !== undefined ? seat.displayName : seat.uid;
                        }

                        newRoom[`seat${i}`] = label;
                    });

                    newRoom['count'] = count;

                    newRooms.push(newRoom);
                });

                dis.setState({
                    rooms: newRooms
                });
            })
            .catch(error => {

                pubSub.pub(pubSub.EVENT_REQUEST_END);

                dis.setState({
                    rooms: []
                });

                pubSub.pub(pubSub.EVENT_REQUEST_ERROR, error);
                console.error('Error getting list of rooms.', error);
            });
    }

    showCreateRoomNameDialog = () => {


        this.setState({ showRoomNameDialog: true });
    }

    hideCreateRoomNameDialog = () => {
        
        this.setState({ showRoomNameDialog: false });
    }

    createRoom = async (roomName, ruleStuck, rulePoints) => {

        const dis = this;
        await this.props.service.createRoom(
            roomName, this.props.userDisplayName, ruleStuck, rulePoints);
        dis.hideCreateRoomNameDialog();
    }

    render() {
        
        if (!this.state.rooms) {
            return <CircularProgress id='progress' />;
        }

        return (
            <div>
                <div className="md-grid">
                    <Button key='refresh' raised primary 
                        onClick={this.loadRooms}
                        iconChildren="refresh" iconBefore={false}
                        className="md-cell--right" 
                    >
                        refresh
                    </Button>
                </div>
                <Grid>
                    {
                        this.state.rooms.map((room, index) => {
                            return <Cell
                                key={index}
                                size={4}>
                                <RoomsItem
                                    key={index}
                                    room={room}
                                    displayName={this.props.userDisplayName}
                                    service={this.props.service}
                                    clickHandler={this.props.service.joinRoom}
                                />
                            </Cell>
                        })
                    }
                </Grid>
                <Button
                    id='rooms-button-add'
                    floating
                    primary
                    fixed
                    onClick={this.showCreateRoomNameDialog}
                >
                    add
                </Button>
                <CreateRoomDialog
                            title='Create room'
                            label='Name'
                            value={this.state.createRoomName}
                            onSubmit={this.createRoom}
                            onCancel={this.hideCreateRoomNameDialog}
                            visible={this.state.showRoomNameDialog} />
               
            </div>
        );
    }
}

export default Rooms;


// WEBPACK FOOTER //
// ./src/Rooms.jsx